<template>
	<v-row class='range-filter py-1 ml-2'>
		<v-col :class='$vuetify.breakpoint.xsOnly ? "" : "mr-11"' class='pa-0 flex-grow-0' cols='12'>
			<v-row no-gutters class='pa-0' cols='12'>
				<v-col class='pa-0 ma-0' :cols='12'>
					<v-row class='ma-0 pa-0 pb-4'>
						<v-col class='font-weight-bold pb-1 ml-0 pl-0' cols='12' style='height: 24px;'>
							<v-radio-group
								v-model='unitIndex'
								row
								class='pa-0 ma-0'
								label='anzeigen als:'
							>
								<v-radio
									v-for='(unit, key) in availableUnits'
									:key='key'
									class='modal-radio-button'
									color='#C62929'
									:label='unit'
									:value='key'
								/>

							</v-radio-group>						</v-col>
					</v-row>
				</v-col>

				<v-col class='pa-0 ma-0' :cols='$vuetify.breakpoint.xsOnly ? 12 : 5'>
					<v-row class='ma-0 pa-0'>
						<v-col class='font-weight-bold pb-1 ml-0 pl-0' cols='12' style='height: 24px;'>
							Von:
						</v-col>
						<v-col cols='12' class='ml-0 pl-0'>
							<v-select
								v-model='min'
								:items='options'
								placeholder='beliebig'
								:error='!!minError'
								clear-icon='far fa-times'
								:suffix='availableUnits[unitIndex]'
								:validate-on-blur='true'
							/>
						</v-col>
						<v-col v-if='!!minError' cols='12'>
							<div class='error--text font-weight-bold pt-1' style='height: 24px'>
								{{ minError }}
							</div>
						</v-col>
					</v-row>
				</v-col>
				<v-col v-if='!$vuetify.breakpoint.xsOnly' cols='1' />
				<v-col class='pa-0 ma-0' :cols='$vuetify.breakpoint.xsOnly ? 12 : 5'>
					<v-row class='ma-0 pa-0'>
						<v-col
							class='font-weight-bold pb-1'
							:class='{
								"pl-0": $vuetify.breakpoint.xsOnly
							}'
							cols='12'
							style='height: 24px;'
						>
							Bis:
						</v-col>
						<v-col
							cols='12'
							:class='{
								"pl-0": $vuetify.breakpoint.xsOnly
							}'
						>
							<v-select
								v-model='max'
								placeholder='beliebig'
								:items='options'
								:error='!!maxError'
								clear-icon='far fa-times'
								:suffix='availableUnits[unitIndex]'
								:validate-on-blur='true'
							/>
						</v-col>
						<v-cols v-if='!!maxError' cols='12'>
							<div class='ml-3 error--text font-weight-bold pt-1' style='height: 24px'>
								{{ maxError }}
							</div>
						</v-cols>
					</v-row>
				</v-col>
			</v-row>
		</v-col>
	</v-row>
</template>

<script>
import BaseFilterMixin from './BaseFilterMixin'

export default {
  name: 'PowerFilter',
  mixins: [BaseFilterMixin],

  data() {
    return {
      unitIndex: 0,
      availableUnits: ['KW', 'PS'],
      min: '',
      max: '',
      ignoreChange: true,
      selectedRange: [0, this.filter.values[0].value] // pass default value to the range (-1|0)
    }
  },

  computed: {
    options() {
      const interval = this.filter.interval
      const max = this.filter.interval_max

      console.assert(interval, 'interval not specified for ' + this.filter)
      console.assert(max, 'interval_max not specified for ' + this.filter)

      const options = [0]
      let currentValue = 0


      let intervalKeys = Object.keys(interval)

      intervalKeys.forEach((key, index) => {
        let nextKey = intervalKeys[index + 1]

        if (!nextKey) nextKey = max
        else nextKey = parseInt(nextKey)

        while (currentValue < nextKey) {
          currentValue += interval[key]
          options.push(currentValue)
        }
      })
      return options
    },

    minError() {
      if (this.min && this.min < 0) return 'Wert darf nicht unter 0 liegen'
      else if (this.min && (this.max || this.max === 0) && this.min > this.max) return 'Von darf nicht größer als bis sein'
      else return ''
    },

    maxError() {
      if (this.max && this.max < 0) return 'Wert darf nicht unter 0 liegen'
      else if (this.max && (this.min || this.min === 0) && this.max < this.min) return 'Bis darf nicht kleiner als von sein'
      else return ''
    },

    hasError() {
      return (this.minError || this.maxError)
    }
  },

  watch: {
    unitIndex(newValue, oldVal) {

      if(!this.ignoreChange) {
        this.ignoreChange = true;
        return;
      }
      if(newValue === 1) {

        //von KW zu PS
        this.min = this.min !== '' ? Math.round(this.min * 1.36) : '';
        this.max = this.max !== '' ? Math.round(this.max * 1.36) : '';

      } else {
        //von PS zu KW
        this.min = this.min !== '' ? Math.round(this.min / 1.36) : '';
        this.max = this.max !== '' ? Math.round(this.max / 1.36) : '';
      }
    },
    min() {
      if (!this.hasError) this.selectedRange = [this.unitIndex, this.min || 0, this.max || this.filter.interval_max]
    },

    max() {
      if (!this.hasError) this.selectedRange = [this.unitIndex, this.min || 0, this.max || this.filter.interval_max]
    },

    selectedRange() {

      const min = this.selectedRange[1]
      const max = this.selectedRange[2]

      if ((!min && min !== 0) && (!max && max !== 0)) {
        this.selectedRange = [this.unitIndex, this.filter.values[0].value] // pass default value to the range (-1|0)
      }

      this.updateFilter([this.selectedRange])
    },
  },
  mounted() {
    const vals = this.filter.selectedValues

    if (vals && vals.length) {
      this.unitIndex = vals[0][0] ?? vals[0].value
      this.min = vals[0][1] ?? vals[1].value
      this.max = vals[0][2] ?? vals[2].value
      if(this.unitIndex !== 0) {
        this.ignoreChange = false;
      }
    }
  },

}
</script>

<style>
.range-filter .input fieldset {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.range-filter .select fieldset {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.range-filter-from-input .v-input__slot, .range-filter-till-input .v-input__slot {
  border-top-left-radius: 3px !important;
  border-bottom-left-radius: 3px !important;
}
.range-filter-from-input fieldset, .range-filter-till-input fieldset  {
  border: 0 !important;
}
.range-filter-from-select fieldset, .range-filter-till-select fieldset {
  border: 0 !important;
}
.range-filter-from-input .v-text-field__slot,
.range-filter-till-input .v-text-field__slot {
  height: 34px !important;
}
.range-filter-from-select .v-input__control, .range-filter-till-select .v-input__control  {
  border-top-right-radius: 3px !important;
  border-bottom-right-radius: 3px !important;
}
.range-filter-from-select .v-input__control .v-select__slot .v-input__append-inner,
.range-filter-till-select .v-input__control .v-select__slot .v-input__append-inner {
  width: 28px !important;
  height: 26px !important;
  margin: 3px 0 0 8px !important;
}
.range-filter-from-select .v-select.icon-only .v-icon, .range-filter-till-select .v-select.icon-only .v-icon {
  font-size: 19px !important;
}
.range-filter-from-select .v-select__slot .v-input__icon.v-input__icon--append,
.range-filter-till-select .v-select__slot .v-input__icon.v-input__icon--append{
  width: 28px !important;
  border-radius: 2px;
  box-shadow: 0 0 3px 1px rgba(185, 185, 185, 0.28) !important;
  border: 1px solid rgba(185, 185, 185, 0.4) !important;
}
.range-filter-from-input input, .range-filter-till-input input {
  font-size: 12px;
}
</style>

<style lang='scss'>
.v-input__slot[role="combobox"] {
  box-shadow: none !important;

  .v-input__append-inner {
    height: 32px;
    width: 32px;
    padding-left: 0 !important;
    margin-right: -14px !important;
    margin-left: 15px;
    border-radius: 3px !important;
    box-shadow: 0 0 3px 1px rgba(185, 185, 185, 0.28) !important;
    border: 1px solid rgba(185, 185, 185, 0.4) !important;
    cursor: pointer;

    .v-input__icon--append {
      height: 32px;
      width: 32px;
    }
  }
}
.input-error {
  background-color: rgba(255,69,0, 0.6)
}
div[role="radiogroup"] {
  legend {
    font-family: Montserrat;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    margin-right: 16px;
  }
}
</style>

<style lang='scss' scoped>
.input, .select {
  display: inline !important;
  flex-grow: 0 !important;
}

.input {
  width: 178px !important;
  max-width: 178px !important;
}

</style>
